<script setup lang="ts">
import type { FloatingBonusTarget } from '@/composables/useFloatingBonus';

defineProps<{
  targets: FloatingBonusTarget[];
}>();

const emit = defineEmits<{
  hit: [id: number];
}>();
</script>

<template>
  <div class="floating-bonus-layer" aria-hidden="true">
    <button
      v-for="target in targets"
      :key="target.id"
      type="button"
      class="floating-bonus-target"
      :style="{ left: `${target.x}px`, top: `${target.y}px` }"
      @click.stop="emit('hit', target.id)"
      @touchstart.prevent.stop="emit('hit', target.id)"
    >
      <span class="floating-bonus-target__emoji">{{ target.emoji }}</span>
    </button>
  </div>
</template>

<style scoped>
.floating-bonus-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 3;
}

.floating-bonus-target {
  position: absolute;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  background: rgb(255 255 255 / 92%);
  box-shadow: 0 8px 24px rgb(0 0 0 / 18%);
  border-radius: 999px;
  width: 3.25rem;
  height: 3.25rem;
  min-width: 48px;
  min-height: 48px;
  cursor: pointer;
  pointer-events: auto;
  animation: bonus-pop 0.18s ease-out;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  font: inherit;
  color: inherit;
}

.floating-bonus-target__emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;
  font-size: 1.65rem;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif;
  letter-spacing: 0;
  text-align: center;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

@media (max-width: 640px) {
  .floating-bonus-target {
    width: 3.5rem;
    height: 3.5rem;
  }

  .floating-bonus-target__emoji {
    font-size: 1.85rem;
  }
}

@keyframes bonus-pop {
  from {
    transform: translate(-50%, -50%) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>
